import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { useSelector } from 'react-redux';
import Routers from './routers';
import { getAntdLocale } from './lib/locale';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const locale = useSelector((state) => state.i18n.locale);

  return (
    <ConfigProvider locale={getAntdLocale(locale)}>
      <BrowserRouter>
        <Routers />
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
